module.exports = __webpack_public_path__ + "static/image/logo-family/logo_goods.ver2_0_2.png?f22b8f26";